import { IFormConfigurationContext } from '@wyz/types';
import { createContext } from 'react';

export const FormContext = createContext<IFormConfigurationContext | undefined>(
  undefined,
);
